<div id="privateMessageComponent" #privateMessageComponent>
  <div
    style="position: relative"
    fxLayout="column"
    fxLayoutGap="10px"
    *ngIf="entity && entity.frontend_user && !mailSent"
  >
    <!-- login clickguard plane -->
    <div
      *ngIf="!userService.user"
      appLoginClickGuard
      style="position: absolute; left: 0px; top: 0px; height: 100%; width: 100%; z-index: 999"
    ></div>

    <div class="mobile-message-heading" style="margin-top: 30px" fxHide.gt-md="true">
      Nachricht an {{ entity.frontend_user.firstname }} {{ entity.frontend_user.lastname }} verfassen
    </div>

    <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">
      <div>
        <div class="tinyheader">Nachricht an {{ getName() }} schreiben</div>

        <div>
          <editor
            apiKey="cirw0hv94c52sgyqp5rseuz1djp09a8nptls2c9a41ypi805"
            [init]="tinyDefaultConfig"
            formControlName="content"
          ></editor>
        </div>

        <mat-error *ngIf="(formSubmitted || form.get('content').touched) && form.get('content').hasError('required')">
          *Bitte schreibe eine Nachricht in das Feld oben
        </mat-error>

        <mat-error
          *ngIf="
            (formSubmitted || form.get('content').touched) &&
            (form.get('content').hasError('minlength') || form.get('content').hasError('maxlength'))
          "
        >
          *Die Nachricht muss zwischen 3 und 10.000 Zeichen lang sein
        </mat-error>
      </div>

      <div class="filter-content">
        <div>Ich möchte über folgende Möglichkeiten kontaktiert werden:</div>

        <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px" fxLayoutGap="15px">
          <!-- email -->
          <div>
            <div class="form-group" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <mat-checkbox style="min-width: 80px" fxShrink="0" formControlName="useMail">E-Mail</mat-checkbox>
              <mat-form-field fxGrow="1">
                <input
                  matInput
                  class="filter-input-fullwidth"
                  formControlName="mail"
                  type="email"
                  placeholder="E-Mail"
                />
              </mat-form-field>
            </div>

            <mat-error
              *ngIf="
                (formSubmitted || form.get('mail').touched) && form.get('useMail').value && form.get('mail').errors
              "
            >
              *Bitte gib eine korrekte E-Mail Adresse an
            </mat-error>

            <mat-error *ngIf="formSubmitted && form.errors && form.errors.atleastone">
              *Bitte aktiviere mindestens eine Kontaktmöglichkeit
            </mat-error>
          </div>

          <!-- telephone -->
          <div>
            <div class="form-group" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <mat-checkbox style="min-width: 80px" fxShrink="0" formControlName="useTel">Telefon</mat-checkbox>
              <mat-form-field fxGrow="1">
                <input
                  matInput
                  type="text"
                  class="filter-input-fullwidth"
                  formControlName="tel"
                  placeholder="Telefon"
                />
              </mat-form-field>
            </div>

            <mat-error
              *ngIf="(formSubmitted || form.get('tel').touched) && form.get('useTel').value && form.get('tel').errors"
            >
              *Bitte gib Deine Telefonnummer an
            </mat-error>
          </div>

          <!-- send button -->
          <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center" fxLayoutAlign.lt-lg="center center">
            <button class="orange-button" (click)="submitForm()">Absenden</button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="mailSent">
    <h2>Vielen Dank! Deine Nachricht wurde versandt.</h2>
  </div>
</div>
